import { Internal } from '../internal';

type CustomFieldType = {
  [K in DirectoryCustomFieldTypes]: string | number | boolean | unknown[];
};

export interface DirectoryCustomField extends Partial<CustomFieldType> {
  id?: number;
  type: DirectoryFieldType;
  value?: string | number | boolean | Date | string[] | null;
}

export interface DirectoryFieldType extends Internal.Dictionary.Generic.Item {
  type?: string;
  showInPublicWebsite?: boolean;
  showInPanel?: boolean;
  created_at?: string;
  updated_at?: string;
}

export enum DirectoryCustomFieldTypes {
  array = 'array',
  int = 'int',
  bool = 'bool',
  text = 'text',
  date = 'date',
  longtext = 'longtext',
}

export interface DirectorySkill extends Internal.Dictionary.Generic.Item {
  skill: string;
  main_skill: boolean;
  is_soft: boolean;
}
